import {
  Box,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemText,
  Switch,
  Typography
} from '@mui/material'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import EDButton from '../../../../../../atoms/EDButton/EDButton'

const UnitsManagementDialog = ({
  isOpen,
  onClose,
  selectedClass,
  currentOpenUnits,
  units,
  onSave,
  programGuid
}) => {
  const { t } = useTranslation()
  const [selectedUnits, setSelectedUnits] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  // Initialize selected units when dialog opens
  useEffect(() => {
    if (isOpen && currentOpenUnits) {
      setSelectedUnits(currentOpenUnits)
    }
  }, [isOpen, currentOpenUnits])

  const handleUnitToggle = (unitNumber) => {
    setSelectedUnits((prev) => {
      if (prev.includes(unitNumber)) {
        return prev.filter((u) => u !== unitNumber)
      } else {
        return [...prev, unitNumber].sort((a, b) => a - b)
      }
    })
  }

  const handleSave = async () => {
    setIsLoading(true)
    try {
      await onSave(selectedClass.guid, selectedUnits)
      onClose()
    } catch (error) {
      // Error is handled in the parent component
      console.error('Error saving units:', error)
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    setSelectedUnits(currentOpenUnits)
    onClose()
  }

  return (
    <Dialog open={isOpen} onClose={handleCancel} maxWidth='sm' fullWidth>
      <DialogTitle>
        <Typography variant='h6'>{t('units_opened')}</Typography>
        <Typography variant='body2' color='text.secondary'>
          {selectedClass?.name}
        </Typography>
      </DialogTitle>

      <DialogContent>
        <Box sx={{ pt: 1, px: 0 }}>
          <List sx={{ px: 0 }}>
            {units.map((unit) => (
              <ListItem
                key={unit.order}
                sx={{
                  borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
                  py: 1.5
                }}
              >
                <ListItemText
                  primary={`#${unit.order} ${unit.name}`}
                  primaryTypographyProps={{
                    fontSize: '0.95rem'
                  }}
                />
                <Switch
                  checked={selectedUnits.includes(unit.order)}
                  onChange={() => handleUnitToggle(unit.order)}
                  disabled={isLoading}
                />
              </ListItem>
            ))}
          </List>
        </Box>
      </DialogContent>

      <DialogActions>
        <EDButton onClick={handleCancel} disabled={isLoading}>
          {t('cancel')}
        </EDButton>
        <EDButton
          onClick={handleSave}
          variant='contained'
          disabled={isLoading}
          startIcon={isLoading && <CircularProgress size={20} />}
        >
          {isLoading ? t('saving') : t('save')}
        </EDButton>
      </DialogActions>
    </Dialog>
  )
}

export default UnitsManagementDialog
